import { render, staticRenderFns } from "./MasqueradeReactivate.vue?vue&type=template&id=e40a12ba&"
import script from "./MasqueradeReactivate.vue?vue&type=script&lang=ts&"
export * from "./MasqueradeReactivate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports